module.exports = __webpack_public_path__ + "img/liveBroadcast_advantage.5783b197.png";